/**
 * Questo file è il punto di ingresso (entry point) dell'applicazione React.
 * - Il suo compito principale è di montare il componente radice (`App`) nel DOM HTML.
 * - Importa gli stili globali, inclusi Bootstrap e stili personalizzati.
 * - Configura il `Provider` di Redux per rendere lo store globale accessibile a tutta l'applicazione.
 * - Inizializza il rendering di React all'interno dell'elemento con id 'root' nel file `public/index.html`.
 */

// --- Importazione degli Stili ---
// Importa i fogli di stile di Bootstrap per avere componenti e layout predefiniti.
import 'bootstrap/dist/css/bootstrap.min.css';
// Importa le icone di Bootstrap.
import 'bootstrap-icons/font/bootstrap-icons.css';
// Importa il bundle JavaScript di Bootstrap, necessario per le funzionalità interattive come dropdown e modal.
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// Importa gli stili globali specifici dell'applicazione.
import './index.css';

// --- Importazione delle Librerie React e Redux ---
import React from 'react';
import ReactDOM from 'react-dom/client'; // Nuovo client renderer per React 18.
import { Provider } from 'react-redux'; // Componente per fornire lo store Redux.
import { store } from './redux/store'; // Lo store Redux precedentemente configurato.

// --- Importazione dei Componenti dell'Applicazione ---
import App from './App'; // Il componente radice dell'applicazione.
import reportWebVitals from './reportWebVitals'; // Utility per misurare le performance.

// --- Rendering dell'Applicazione ---

// 1. Crea il "root" di React, agganciandosi all'elemento del DOM con id 'root'.
//    Questo è il contenitore principale dove vivrà l'intera applicazione.
const root = ReactDOM.createRoot(document.getElementById('root'));

// 2. Esegue il rendering dell'applicazione all'interno del root.
root.render(
  // `React.StrictMode` è un wrapper che aiuta a identificare potenziali problemi
  // nell'applicazione durante lo sviluppo, attivando controlli e avvisi aggiuntivi.
  <React.StrictMode>
    {/*
      Il `Provider` è un componente di React-Redux che avvolge l'intera applicazione.
      Riceve lo `store` come prop e lo rende disponibile a qualsiasi componente
      che ne abbia bisogno tramite i hook `useSelector` e `useDispatch`.
    */}
    <Provider store={store}>
      {/* `App` è il componente che contiene tutta la logica di routing e visualizzazione. */}
      <App />
    </Provider>
  </React.StrictMode>
);

// --- Misurazione delle Performance (Opzionale) ---
// La funzione `reportWebVitals` può essere usata per inviare metriche di performance
// (come LCP, FID, CLS) a un servizio di analytics per monitorare le prestazioni reali dell'app.
reportWebVitals();